"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Wizard = require("../Wizard/Wizard");
var _RetirementIncomeGapWizardCalcConfig = require("./RetirementIncomeGapWizardCalc.config.js");
var _ProgressBarStepList = _interopRequireDefault(require("../Wizard/ProgressBarStepList"));
var _axios = _interopRequireDefault(require("axios"));
var _CalculatorTemplate = require("../Wizard/CalculatorTemplate");
var _utils = require("../../middleware/utils");
var _PageOneSideContent = _interopRequireDefault(require("./ForcedSideContent/PageOneSideContent"));
var _PageTwoSideContent = _interopRequireDefault(require("./ForcedSideContent/PageTwoSideContent"));
var _PageThreeSideContent = _interopRequireDefault(require("./ForcedSideContent/PageThreeSideContent"));
var _PageFourSideContent = _interopRequireDefault(require("./ForcedSideContent/PageFourSideContent"));
var _PageFiveSideContent = _interopRequireDefault(require("./ForcedSideContent/PageFiveSideContent"));
var _RetirementIncomeGapPageOne = _interopRequireDefault(require("./RetirementIncomeGapPageOne"));
var _RetirementIncomeGapPageTwo = _interopRequireDefault(require("./RetirementIncomeGapPageTwo"));
var _RetirementIncomeGapPageThree = _interopRequireDefault(require("./RetirementIncomeGapPageThree"));
var _RetirementIncomeGapPageFour = _interopRequireDefault(require("./RetirementIncomeGapPageFour"));
var _RetirementIncomeGapPageFive = _interopRequireDefault(require("./RetirementIncomeGapPageFive"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } /* eslint-disable no-tabs */
var RetirementIncomeGapWizardCalc = props => {
  var {
    config
  } = props;
  var [stepNumber, setStepNumber] = (0, _react.useState)(0);
  var [snapshot, setSnapshot] = (0, _react.useState)({});
  var [apiData, setApiData] = (0, _react.useState)(null);
  var [errorData, setErrorData] = (0, _react.useState)(null);
  var [validationData, setValidationData] = (0, _react.useState)(null);
  var [currentExpenses, setCurrentExpenses] = (0, _react.useState)(0);
  var [futureExpenses, setFutureExpenses] = (0, _react.useState)(0);
  var [hasRetirementIncomeGap, setHasRetirementIncomeGap] = (0, _react.useState)(false);
  var currentConfig = config.Steps[stepNumber];
  var progressSteps = ['About You', 'Expenses', 'Future Expenses', 'Future Income', 'Results'];
  var fetchDataScienceResults = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(function* () {
      // Reset error data to get rid of any Alerts
      setErrorData(null);
      try {
        /* istanbul ignore else */
        if (!apiData) {
          var payload = {
            placeholder: 'string'
          };
          var result = yield _axios.default.post(config.API_URL, payload);
          setApiData(result.data);
        }
      } catch (err) {
        console.error(err);
        setErrorData(err.message);
        throw Error('Unexpected error');
      }
    });
    return function fetchDataScienceResults() {
      return _ref.apply(this, arguments);
    };
  }();

  // Refinement modal handlers here
  var [showRefineModal, setShowRefineModal] = (0, _react.useState)(false);
  var refinementHandleClose = () => {
    setValidationData(null);
    setShowRefineModal(false);
  };
  var handleShow = values => {
    (0, _utils.customTealiumEvent)(_RetirementIncomeGapWizardCalcConfig.calcName, 'click', 'changeYourAssumptions');
    setSnapshot(values);
    setShowRefineModal(true);
    setValidationData(_RetirementIncomeGapWizardCalcConfig.validationRefinementModal);
  };

  // Disclosure modal handler here
  var [showDisclosureModal, setShowDisclosureModal] = (0, _react.useState)(false);
  var disclosureHandleClose = () => {
    setShowDisclosureModal(false);
  };
  var disclosureHandleShow = () => {
    (0, _utils.customTealiumEvent)(_RetirementIncomeGapWizardCalcConfig.calcName, 'click', 'disclosure');
    setShowDisclosureModal(true);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    id: _RetirementIncomeGapWizardCalcConfig.calcName
  }, /*#__PURE__*/_react.default.createElement(_ProgressBarStepList.default, {
    subtitle: progressSteps[stepNumber],
    activeStep: stepNumber + 1,
    steps: 5
  }), /*#__PURE__*/_react.default.createElement(_CalculatorTemplate.CalculatorTemplate, {
    config: config,
    currentConfig: currentConfig,
    stepNumber: stepNumber,
    customSideContent: [/*#__PURE__*/_react.default.createElement(_PageOneSideContent.default, {
      key: 1
    }), /*#__PURE__*/_react.default.createElement(_PageTwoSideContent.default, {
      currentExpenses: currentExpenses,
      key: 2
    }), /*#__PURE__*/_react.default.createElement(_PageThreeSideContent.default, {
      currentExpenses: currentExpenses,
      futureExpenses: futureExpenses,
      key: 3
    }), /*#__PURE__*/_react.default.createElement(_PageFourSideContent.default, {
      socialSecurityBenefit: (apiData === null || apiData === void 0 ? void 0 : apiData.socialSecurityBenefit) || 1905.0,
      key: 4
    }), /*#__PURE__*/_react.default.createElement(_PageFiveSideContent.default, {
      hasRetirementIncomeGap: hasRetirementIncomeGap,
      key: 5
    })]
  }, /*#__PURE__*/_react.default.createElement(_Wizard.Wizard, {
    passthroughId: "retirementIncomeGapCalc",
    setStepNumber: setStepNumber,
    stepNumber: stepNumber,
    initialValues: _RetirementIncomeGapWizardCalcConfig.initialValuesConfig,
    initialTouched: _RetirementIncomeGapWizardCalcConfig.initialTouchedConfig,
    onSubmit: () => {},
    currentConfig: currentConfig,
    validationData: validationData,
    errorData: errorData,
    calcName: _RetirementIncomeGapWizardCalcConfig.calcName,
    maxSteps: 5,
    isNotNatLang: [false, true, true, false, true],
    centerNavButtons: [false, true, true, false, false]
  }, /*#__PURE__*/_react.default.createElement(_Wizard.WizardStep, {
    onSubmit: fetchDataScienceResults,
    validationSchema: _RetirementIncomeGapWizardCalcConfig.validationConfig[0]
  }, /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapPageOne.default, null)), /*#__PURE__*/_react.default.createElement(_Wizard.WizardStep, {
    onSubmit: null,
    validationSchema: _RetirementIncomeGapWizardCalcConfig.validationConfig[1]
  }, /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapPageTwo.default, {
    apiData: apiData,
    setValidationData: setValidationData,
    setCurrentExpenses: setCurrentExpenses
  })), /*#__PURE__*/_react.default.createElement(_Wizard.WizardStep, {
    onSubmit: null,
    validationSchema: _RetirementIncomeGapWizardCalcConfig.validationConfig[2]
  }, /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapPageThree.default, {
    setFutureExpenses: setFutureExpenses
  })), /*#__PURE__*/_react.default.createElement(_Wizard.WizardStep, {
    onSubmit: null,
    validationSchema: _RetirementIncomeGapWizardCalcConfig.validationConfig[3]
  }, /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapPageFour.default, {
    setHasRetirementIncomeGap: setHasRetirementIncomeGap
  })), /*#__PURE__*/_react.default.createElement(_Wizard.WizardStep, {
    onSubmit: handleShow,
    validationSchema: null,
    nextButtonAsTypeButton: true,
    sideButtonOnClick: disclosureHandleShow
  }, /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapPageFive.default, {
    setValidationData: setValidationData,
    snapshot: snapshot,
    showDisclosure: showDisclosureModal,
    disclosureHandleClose: disclosureHandleClose,
    setHasRetirementIncomeGap: setHasRetirementIncomeGap,
    showRefinement: showRefineModal,
    refinementHandleClose: refinementHandleClose,
    setSnapshot: setSnapshot,
    currentExpenses: currentExpenses,
    setCurrentExpenses: setCurrentExpenses,
    futureExpenses: futureExpenses,
    setFutureExpenses: setFutureExpenses
  })))));
};
var _default = exports.default = RetirementIncomeGapWizardCalc;